import { render, staticRenderFns } from "./ExtendedReport.vue?vue&type=template&id=1f68c7a2&"
import script from "./ExtendedReport.vue?vue&type=script&lang=ts&"
export * from "./ExtendedReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports